import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actionCreators } from 'react/api/actions/routeSurveyModal';
import * as selectors from 'react/api/selectors/routeSurveyModal';
import Loading from 'react/components/Loading';
import PhotoGallery from 'react/components/PhotoGallery.js';

class SurveyAnswerSignature extends React.Component {
  componentDidMount() {
    const { fetchSignatureAnswerAction, surveyAnswerId, signatureAnswer, routeId, stopId } = this.props;

    if (!signatureAnswer?.get('base64Image')) {
      fetchSignatureAnswerAction({ routeId, stopId, surveyAnswerId});
    }
  }

  render() {
    const { signatureAnswer, isLoading } = this.props;
    return (
      <div className="route-survey-modal__survey-answer-signature">
        {isLoading ? <Loading height="100%" /> : <PhotoGallery signaturePhoto={signatureAnswer} />}
      </div>
    );
  }
}

SurveyAnswerSignature.propTypes = {
  // state
  routeId: PropTypes.string.isRequired,
  stopId: PropTypes.string,
  surveyAnswerId: PropTypes.string.isRequired,
  signatureAnswer: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  // actions
  fetchSignatureAnswerAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  signatureAnswer: selectors.getSignatureAnswer(state, ownProps),
  isLoading: selectors.getIsLoadingSignatureAnswer(state, ownProps)
});

const mapDispatchToProps = {
  fetchSignatureAnswerAction: actionCreators.fetchSignatureAnswer
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyAnswerSignature);
